<template>
  <base-section
    id="features"
    class="secondary"
  >
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="4"
          >
            <base-info-card
              align="center"
              dark
              v-bind="card"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          icon: 'mdi-handshake',
          title: 'Commitment',
          text: 'We do our work with full responsibility and professionalism. If we decide to tackle a new project, it is because we are willing to give our best and a little more. We seek to obtain the best possible result, either developing our own product or providing an outsourced service.',
        },
        {
          icon: 'mdi-rocket-launch-outline',
          title: 'Agility',
          text: 'We work with agile methodologies, mainly SCRUM, and we believe that it is the best way to manage our projects. With customer and user satisfaction as a priority, delivering frequent releases, receiving feedback on each iteration, and adapting requirements with tangible early results.',
        },
        {
          icon: 'mdi-lightbulb-on-outline',
          title: 'Innovation',
          text: 'We always focus on learning new technologies to improve the quality of our developments and services. As young entrepreneurs we are also constantly thinking about disruptive approaches to solve the problems we face.',
        },
      ],
    }),
  }
</script>
